module.exports = __webpack_public_path__ + "img/Icon-insta.85c1da1b.svg";